export default "__VITE_ASSET__d0b30997__"